import { render, staticRenderFns } from "./KidDashboard.vue?vue&type=template&id=4f88e2d2&scoped=true&"
import script from "./KidDashboard.vue?vue&type=script&lang=js&"
export * from "./KidDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KidDashboard.vue?vue&type=style&index=0&id=4f88e2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88e2d2",
  null
  
)

export default component.exports